import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import LoadingCircular from '../LoadingCircular';
import { Box } from '@mui/material';

interface QrCodeModalProps {
  showQrCode: boolean;
  setShowQrCode: React.Dispatch<React.SetStateAction<boolean>>;
  qrCode: string;
}

export default function QrCode({ showQrCode, setShowQrCode, qrCode }: QrCodeModalProps) {
  return (
    <Dialog
      open={showQrCode}
      onClose={() => setShowQrCode(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {"Escaneie com seu WhatsApp:"}
      </DialogTitle>
      <DialogContent>
        <Box id="alert-dialog-description"
          // component='div'
          sx={{ textAlign: 'center' }}>
          {qrCode.includes('Carregando') ? (
            <LoadingCircular />
          ) : (
            <img src={qrCode} alt="QrCode" style={{ width: '200px' }} />
          )}
        </Box>
      </DialogContent>
    </Dialog>
  );
}
